
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ed935b92&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ListarNotificacoes.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ListarNotificacoes.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-ed935b92!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ListarNotificacoes.vue"),
  /* scopeId */
  "data-v-ed935b92",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/notificacao/ListarNotificacoes.vue
// module id = 906
// module chunks = 1